import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import primaryComponents from "../../primaryComponents";
import useVatLogsExport from "./useVatLogsExport";
import Validation from "./Validation";
import { Controller } from "react-hook-form";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";

const VatLogsExport = ({ closeWidget, selectStartDate, selectedEndDate }) => {
  const {
    exportFormat,
    startDate,
    endDate,
    selectedStores,
    storeList,
    transactionType,
    exportVatLogsMutation,
    setStartDate,
    setEndDate,
    setSelectedStores,
    setExportFormat,
    setTransactionType,
    handleExportVatLog,
  } = useVatLogsExport({
    closeWidget,
    selectStartDate,
    selectedEndDate,
  });
  const {
    control,
    register,
    formState: { errors },
    trigger,
    handleSubmit,
  } = Validation(
    exportFormat,
    startDate,
    endDate,
    selectedStores,
    transactionType,
  );
  const transactionTypeOptions = [
    { name: "Collected VAT", value: "OUTFLOW" },
    { name: "VAT ON Purchases", value: "INFLOW" },
  ];

  return (
    <div className={globalStyles.pageColumnGaps} style={{ minHeight: "100%" }}>
      <div>
        <primaryComponents.Button
          classNames={"btn btn--outline smallBtn"}
          onClick={closeWidget}
        >
          <FontAwesomeIcon icon="angle-left" style={{ fontSize: "15px" }} />
        </primaryComponents.Button>
      </div>

      <div>
        <h4>Export VAT</h4>
        <p>
          Export your VAT logs in either PDF or Excel format. Select the desired
        </p>
      </div>

      <form
        className={globalStyles.pageColumnGaps}
        style={{ gap: "10px" }}
        id="exportVatLog"
        onSubmit={handleSubmit((values) => handleExportVatLog(values))}
      >
        <div>
          <label className="mb-1">
            <span className="error--text">*</span>File Format
          </label>
          <div className="mb-3">
            <primaryComponents.BoxedRadioInput
              control={control}
              name="exportFormat"
              value={exportFormat}
              id="pdf"
              isChecked={exportFormat === "pdf"}
              setRadioValue={() => {
                setExportFormat("pdf");
              }}
            >
              <span className="font-weight-semibold">PDF</span>
            </primaryComponents.BoxedRadioInput>
          </div>
          <div>
            <primaryComponents.BoxedRadioInput
              control={control}
              name="exportFormat"
              value={exportFormat}
              id="excel"
              isChecked={exportFormat === "excel"}
              setRadioValue={() => {
                setExportFormat("excel");
              }}
            >
              <span className="font-weight-semibold">Excel</span>
            </primaryComponents.BoxedRadioInput>
          </div>
        </div>
        <div>
          <label className="mb-1">
            <span className="error--text">*</span>Date Range
          </label>
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ width: "max-content" }}>
              <primaryComponents.DateInputV2
                control={control}
                name="startDate"
                value={startDate}
                classNames="white"
                isRequired={true}
                errorMessage={errors.startDate}
                onChange={({ target: { value } }) => {
                  setStartDate(value);
                }}
                onKeyUp={() =>
                  errors.startDate !== undefined && trigger("startDate")
                }
                register={register}
              />
            </div>
            <span>To</span>
            <div style={{ width: "max-content" }}>
              <primaryComponents.DateInputV2
                control={control}
                name="endDate"
                value={endDate}
                classNames="white"
                isRequired={true}
                errorMessage={errors.endDate}
                onChange={({ target: { value } }) => {
                  setEndDate(value);
                }}
                onKeyUp={() =>
                  errors.endDate !== undefined && trigger("endDate")
                }
                register={register}
              />
            </div>
          </div>
        </div>
        <Controller
          name="transaction type"
          control={control}
          defaultValue={selectedStores}
          render={({ field: { onChange } }) => (
            <primaryComponents.MultipleSelectField
              options={storeList}
              idKey="id"
              nameKey="name"
              value={selectedStores || "Select Store"}
              placeholder="Select Store"
              label="Select Store(s)"
              errorMessage={errors.selectedStores}
              onChange={(values) => {
                onChange(values);
                let newValues = [];
                values?.forEach((item) => {
                  newValues.push(item.value);
                });
                setSelectedStores(newValues);
              }}
            />
          )}
        />
        <primaryComponents.SelectField
          options={transactionTypeOptions}
          idKey="value"
          nameKey="name"
          value={transactionType}
          placeholder="Select Transaction"
          label="Transaction Type"
          errorMessage={errors.transactionType}
          onChange={(value) => {
            setTransactionType(value);
          }}
        />
      </form>

      <primaryComponents.Button
        classNames="btn btn--primary mt-auto"
        isLoading={exportVatLogsMutation?.isLoading}
        loadingText="Exporting..."
        isDisabled={exportVatLogsMutation?.isLoading}
        type="submit"
        form="exportVatLog"
      >
        Exporting
      </primaryComponents.Button>
    </div>
  );
};

export default VatLogsExport;
